export const TILE_DATA = [
  {
    id: 'frontend',
    title: 'Frontend',
    items: ['React', 'JavaScript', 'TypeScript', 'Bootstrap'],
    accent: 'var(--accent-1)',
  },
  {
    id: 'backend',
    title: 'Backend',
    items: [
      'Node.js',
      'Express.js',
      'Core Java',
      'Spring Boot',
      'Play MVC',
      'sbt',
      'REST APIs',
      'WebSockets',
      'JWT',
    ],
    accent: 'var(--accent-2)',
  },
  {
    id: 'devops',
    title: 'DevOps & Cloud',
    items: ['Docker', 'Git', 'Jenkins', 'AWS', 'GCP', 'EC2', 'S3', 'Linux', 'Nginx'],
    accent: 'var(--accent-3)',
  },
  {
    id: 'database',
    title: 'Database',
    items: ['MongoDB', 'Redis', 'PostgreSQL'],
    accent: 'var(--accent-4)',
  },
  {
    id: 'architecture',
    title: 'Architecture & Design',
    items: ['Microservices Architecture', 'Monolith Architecture'],
    accent: 'var(--accent-1)',
  },
  {
    id: 'system-design',
    title: 'System Design & Scalability',
    items: ['Load Balancing', 'Caching Strategies', 'Horizontal vs Vertical Scaling'],
    accent: 'var(--accent-2)',
  },
  {
    id: 'security',
    title: 'Security',
    items: ['HTTPS / SSL', 'CORS'],
    accent: 'var(--accent-3)',
  },
]
